import { PlayerSessionShared } from "@shared/types";
import sendAddInventoryItemRequest from "../services/Player/send-add-inventory-item-request";
import sendGetPlayerSessionRequest from "../services/Player/send-get-playersession-request";
import sendSwitchRoomRequest from "../services/Player/send-switch-room-request";
import sendChangeStatusRequest from "../services/Player/send-status-change-request";
// import sendRemoveInventoryItemRequest from "../services/Player/send-remove-inventory-item-request";
import { healthEffect } from "./types/class-user.types";
import sendChangePlayerHitpointsRequest from "../services/Player/send-change-player-hitpoints-request";
import sendResetLocalGameRequest from "../services/Player/send-reset-game-request";

export class DialogueHandler {
    // public currentDialogue: number;
    // public currentChoiceId: number;

    public constructor() {
        // this.currentDialogue = currentDialogue;
        // this.currentChoiceId = choiceId;
    }

    // Get function to retreive the current player's session from the server.
    public async getPlayerSession(): Promise<PlayerSessionShared | null> {
        const playerSessionInfo: PlayerSessionShared | null = await sendGetPlayerSessionRequest();

        if (!playerSessionInfo) {
            return null;
        }

        return playerSessionInfo;
    }

    // Handler function for changing a status of the player in the current session.
    private async _changePlayerStatusProperty(status: string, effect: boolean): Promise<void> {
        await sendChangeStatusRequest(status, effect);

        return;
    }

    // Handler function for adding an item to the player's inventory in the current session.
    private async _addItemToPlayerInventory(itemName: string): Promise<void> {
        await sendAddInventoryItemRequest(itemName);

        return;
    }

    // Handler function for removing an item from the player's inventory in the current session.
    // private async _removeItemFromPlayerInventory(itemName: string): Promise<void> {
    //     await sendRemoveInventoryItemRequest(itemName);

    //     return;
    // }

    // Handler function for changing the player's current room in the current session.
    private async _changeCurrentRoomPlayer(roomName: string): Promise<void> {
        await sendSwitchRoomRequest(roomName);

        return;
    }

    // Handler function for changing the player's hitpoints in the current session.
    private async _changePlayerHitpoints(amount: number, effect: healthEffect): Promise<void> {
        await sendChangePlayerHitpointsRequest(amount, effect);

        return;
    }

    // Prologue 1
    public async handleDialoguesPrologueFirst(choiceId: number, dialogueId: number): Promise<number> {
        if (choiceId === 1 && dialogueId === 1) {
            return 2;
        }

        if (choiceId === 1 && dialogueId === 2) {
            return 3;
        }

        if (choiceId === 1 && dialogueId === 3) {
            return 4;
        }

        if (choiceId === 1 && dialogueId === 4) {
            // EXAMPLE USE OF GETTING THE CURRENT PLAYER SESSION AND ALL STATUSES
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();
            console.log(playerSession?.hasCleanedHands);

            return 5;
        }

        // Bring the pocket knife
        if (choiceId === 1 && dialogueId === 5) {
            // ROUTE TO BACK END INVENTORY OF SESSION TO ADD THE POCKET KNIFE TO INVENTORY
            await this._addItemToPlayerInventory("PocketKnifeItem");
            return 6;
        }

        // Leave without the pocket knife
        if (choiceId === 2 && dialogueId === 5) {
            return 6;
        }

        // End of the first prologue, needs to enter the second prologue on this choice.
        if (choiceId === 1 && dialogueId === 6) {
            await this._changePlayerStatusProperty("completedPrologueFirst", true);

            await this._changeCurrentRoomPlayer("PrologueSecond");
            return 99;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 1;
    }

    // Prologue 1 (ON RETURN)
    public async handleDialoguesPrologueFirstReturn(choiceId: number, dialogueId: number): Promise<number> {
        if (dialogueId === 7 && choiceId === 1) {
            await this.getPlayerSession();
            return 8;
        }

        if (dialogueId === 8 && choiceId === 1) {
            return 9;
        }

        if (dialogueId === 9 && choiceId === 1) {
            return 10;
        }

        if (dialogueId === 10 && choiceId === 1) {
            return 11;
        }

        if (dialogueId === 11 && choiceId === 1) {
            return 7;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 1;
    }

    // Prologue 2
    public async handleDialoguesPrologueSecond(choiceId: number, dialogueId: number): Promise<number> {
        if (choiceId === 1 && dialogueId === 1) {
            return 2;
        }

        if (choiceId === 1 && dialogueId === 2) {
            return 3;
        }

        if (choiceId === 1 && dialogueId === 3) {
            return 4;
        }

        if (choiceId === 1 && dialogueId === 4) {
            return 5;
        }

        // End of the prologue, needs to enter bathroom on this choice.
        if (choiceId === 1 && dialogueId === 5) {
            await this._changePlayerStatusProperty("completedPrologueSecond", true);

            await this._changePlayerHitpoints(40, "lose");

            await this._changeCurrentRoomPlayer("Bathroom");
            return 99;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 1;
    }

    // Prologue 2 (ON RETURN)
    public async handleDialoguesPrologueSecondReturn(choiceId: number, dialogueId: number): Promise<number> {
        if (choiceId === 1 && dialogueId === 1) {
            await this.getPlayerSession();
            return 2;
        }

        if (choiceId === 1 && dialogueId === 2) {
            return 3;
        }

        if (choiceId === 1 && dialogueId === 3) {
            return 4;
        }

        if (choiceId === 1 && dialogueId === 4) {
            return 6;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 1;
    }

    // Bathroom
    public async handleDialoguesBathroom(choiceId: number, dialogueId: number): Promise<number> {
        // Look around
        if (dialogueId === 1 && choiceId === 1) {
            return 2;
        }

        // Rub your eyes, if looked before rub.
        if (dialogueId === 2 && choiceId === 1) {
            return 2;
        }

        // Rub your eyes
        if (dialogueId === 2 && choiceId === 2) {
            return 3;
        }

        // Look around
        if (dialogueId === 3 && choiceId === 1) {
            return 4;
        }

        // Look into the mirror
        if (dialogueId === 4 && choiceId === 1) {
            return 5;
        }

        // Look around the room
        if (dialogueId === 5 && choiceId === 1) {
            return 6;
        }

        // Look deeper into the mirror
        if (dialogueId === 5 && choiceId === 2) {
            return 7;
        }

        // Look at the wall behind you
        if (dialogueId === 7 && choiceId === 1) {
            return 8;
        }

        // Ignore the wall, walk around the room
        if (dialogueId === 7 && choiceId === 2) {
            return 6;
        }

        // Read the words
        if (dialogueId === 8 && choiceId === 1) {
            await this._changePlayerStatusProperty("hasReadBathroomWall", true);
            return 9;
        }

        // Look around the room
        if (dialogueId === 9 && choiceId === 1) {
            return 6;
        }

        // Check the bathroom door (again)
        if (
            (dialogueId === 6 && choiceId === 1) ||
            (dialogueId === 11 && choiceId === 2) ||
            (dialogueId === 12 && choiceId === 2)
        ) {
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();

            // Player did all tasks to unlock the next room - SUCCESS
            if (playerSession?.hasCleanedHands === true && playerSession?.hasUsedDoorKnob === true) {
                // Dialogue to exit the room
                return 10;
            }

            // Player has not cleaned his hand, but has attached the found door knob to the bathroom door
            if (playerSession?.hasCleanedHands === false && playerSession?.hasUsedDoorKnob === true) {
                // Dialogue door has door knob, but no hand grip.
                return 11;
            }

            // Player has not completed the required actions to open the bathroom door.
            if (playerSession?.hasCleanedHands === false || playerSession?.hasUsedDoorKnob === false) {
                return 12;
            }

            return 6;
        }

        // Pick up the door knob
        if (dialogueId === 6 && choiceId === 2) {
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();
            if (playerSession?.hasUsedDoorKnob === true) {
                return 6;
            }

            // ROUTE TO BACK END INVENTORY OF SESSION TO ADD THE DoorKnob TO THE INVENTORY
            await this._addItemToPlayerInventory("DoorKnobItem");
            return 6;
        }

        // Pick up the towel from the rack
        if (dialogueId === 6 && choiceId === 3) {
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();
            if (playerSession?.hasCleanedHands === true) {
                return 6;
            }

            // ROUTE TO BACK END INVENTORY OF SESSION TO ADD THE BathroomTowel TO THE INVENTORY
            await this._addItemToPlayerInventory("BathroomTowelItem");
            return 6;
        }

        // RESET TO LOOK AROUND THE ROOM
        if (
            (dialogueId === 11 && choiceId === 1) ||
            (dialogueId === 12 && choiceId === 1) ||
            (dialogueId === 14 && choiceId === 2) ||
            (dialogueId === 15 && choiceId === 2)
        ) {
            return 6;
        }

        // Take a deep breath
        if (dialogueId === 5 && choiceId === 3) {
            return 13;
        }

        // Smash the locked door (HP -5)
        if (dialogueId === 13 && choiceId === 1) {
            await this._changePlayerHitpoints(5, "lose");
            return 14;
        }

        // Smash the locked door again (HP -10)
        if (dialogueId === 14 && choiceId === 1) {
            await this._changePlayerHitpoints(10, "lose");
            return 15;
        }

        // Smash the locked door again (HP -5)
        if (dialogueId === 15 && choiceId === 1) {
            await this._changePlayerHitpoints(5, "lose");
            return 16;
        }

        // Smash the locked door one last time
        if (dialogueId === 16 && choiceId === 1) {
            return 17;
        }

        // Leave the bathroom (Through door knob method OR through smash door method)
        if ((dialogueId === 10 && choiceId === 1) || (dialogueId === 17 && choiceId === 1)) {
            await this._changePlayerStatusProperty("completedBathroom", true);

            // SWITCH REQUEST TO GO TO EMIR's ROOM.
            await sendSwitchRoomRequest("4");
            return 99;
        }

        // RESET ROOM
        if (dialogueId === 99 && choiceId === 1) {
            return 1;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 1;
    }

    // Bathroom (ON RETURN)
    public async handleDialoguesBathroomReturn(choiceId: number, dialogueId: number): Promise<number> {
        // Look around
        if (dialogueId === 30 && choiceId === 1) {
            return 31;
        }

        // Look at the strange wall
        if (dialogueId === 31 && choiceId === 1) {
            return 33;
        }

        // Inspect the strange object
        if (dialogueId === 31 && choiceId === 2) {
            await this._changePlayerStatusProperty("hasNoticedCamera", true);
            return 32;
        }

        // Inspect the strange object
        if (dialogueId === 32 && choiceId === 1) {
            return 30;
        }

        // Read the words on the wall
        if (dialogueId === 33 && choiceId === 1) {
            await this._changePlayerStatusProperty("hasReadBathroomWall", true);
            return 34;
        }

        // Read the words on the wall
        if (dialogueId === 34 && choiceId === 1) {
            return 31;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 30;
    }

    // Basement
    public async handleDialoguesBasement(choiceId: number, dialogueId: number): Promise<number> {
        // Describe choice label to keep track easily
        if (dialogueId === 1 && choiceId === 1) {
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();
            console.log(playerSession);
            return 2;
        }

        if (dialogueId === 2 && choiceId === 1) {
            return 3;
        }

        if (dialogueId === 3 && choiceId === 1) {
            return 4;
        }
        // MULTIPLE CHOICE
        if (dialogueId === 3 && choiceId === 2) {
            return 20;
        }

        if (dialogueId === 4 && choiceId === 1) {
            return 5;
        }
        // MULTIPLE CHOICE
        if (dialogueId === 4 && choiceId === 2) {
            return 6;
        }

        if (dialogueId === 5 && choiceId === 1) {
            return 7;
        }

        if (dialogueId === 6 && choiceId === 1) {
            return 5;
        }
        // MULTIPLE CHOICE
        if (dialogueId === 6 && choiceId === 2) {
            return 21;
        }

        if (dialogueId === 7 && choiceId === 1) {
            return 8;
        }

        if (dialogueId === 8 && choiceId === 1) {
            return 9;
        }

        if (dialogueId === 9 && choiceId === 1) {
            return 10;
        }

        if (dialogueId === 10 && choiceId === 1) {
            return 11;
        }

        if (dialogueId === 11 && choiceId === 1) {
            return 12;
        }

        if (dialogueId === 12 && choiceId === 1) {
            return 13;
        }

        if (dialogueId === 13 && choiceId === 1) {
            return 14;
        }

        if (dialogueId === 14 && choiceId === 1) {
            return 15;
        }

        if (dialogueId === 15 && choiceId === 1) {
            return 16;
        }
        // ENDING: BAD ENDING
        if (dialogueId === 16 && choiceId === 1) {
            // FINISH GAME, BACK TO START GAME
            return 98;
        }

        if (dialogueId === 20 && choiceId === 1) {
            return 21;
        }

        if (dialogueId === 20 && choiceId === 2) {
            return 4;
        }

        if (dialogueId === 21 && choiceId === 1) {
            return 22;
        }

        if (dialogueId === 22 && choiceId === 1) {
            return 23;
        }

        if (dialogueId === 23 && choiceId === 1) {
            return 24;
        }

        if (dialogueId === 24 && choiceId === 1) {
            return 25;
        }

        if (dialogueId === 25 && choiceId === 1) {
            return 26;
        }

        if (dialogueId === 26 && choiceId === 1) {
            return 27;
        }

        if (dialogueId === 27 && choiceId === 1) {
            return 29;
        }

        // DUPLICATE WHOOPS
        if (dialogueId === 28 && choiceId === 1) {
            return 29;
        }

        if (dialogueId === 29 && choiceId === 1) {
            return 30;
        }

        if (dialogueId === 30 && choiceId === 1) {
            return 31;
        }

        if (dialogueId === 31 && choiceId === 1) {
            return 32;
        }

        if (dialogueId === 32 && choiceId === 1) {
            return 35;
        }
        // MULTIPLE CHOICE
        if (dialogueId === 32 && choiceId === 2) {
            // (item: LetterItemAlias, hasReadBathroomWall === true, Strange object talk to choice 2)
            // IF STATEMENT TOWARDS GOOD ENDING
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();
            console.log(playerSession);
            // IF STATEMENT TOWARDS GOOD ENDING
            if (playerSession?.completedBathroom) {
                return 60;
            }

            return 34;
        }
        // MULTIPLE CHOICE
        if (dialogueId === 32 && choiceId === 3) {
            const playerSession: PlayerSessionShared | null = await this.getPlayerSession();
            console.log(playerSession);
            // IF STATEMENT TOWARDS GOOD ENDING
            if (playerSession?.completedBathroom) {
                return 50;
            }

            return 33;
        }

        if (dialogueId === 33 && choiceId === 1) {
            return 36;
        }

        if (dialogueId === 34 && choiceId === 1) {
            return 36;
        }

        if (dialogueId === 35 && choiceId === 1) {
            return 36;
        }

        if (dialogueId === 36 && choiceId === 1) {
            return 37;
        }

        if (dialogueId === 37 && choiceId === 1) {
            return 38;
        }

        if (dialogueId === 38 && choiceId === 1) {
            return 39;
        }
        // ENDING: MIDDLE BAD ENDING DONE
        if (dialogueId === 39 && choiceId === 1) {
            return 98;
        }

        // FILLER OPTION 3 GOOD ENDING
        if (dialogueId === 50 && choiceId === 1) {
            return 51;
        }

        if (dialogueId === 51 && choiceId === 1) {
            return 52;
        }

        if (dialogueId === 52 && choiceId === 1) {
            return 53;
        }

        if (dialogueId === 53 && choiceId === 1) {
            return 54;
        }

        if (dialogueId === 54 && choiceId === 1) {
            return 98;
        }

        // FILLER OPTION 2 GOOD ENDING
        if (dialogueId === 60 && choiceId === 1) {
            return 51;
        }

        if (dialogueId === 98 && choiceId === 1) {
            // END
            await sendResetLocalGameRequest();

            return 99;
        }

        if (dialogueId === 99 && choiceId === 1) {
            // RESET CANVAS

            return 1;
        }

        // Makes sure the room does't break by always having a dialogue option
        return 1;
    }
}
